import { createColumnHelper } from "@tanstack/react-table"
import { Link } from "react-router-dom"
import { Tooltip } from "react-tooltip"

const columnHelper = createColumnHelper()

export const holdColumns = [
  columnHelper.accessor("id", {
    header: () => "ID",
  }),
  columnHelper.accessor("account", {
    header: () => "Account",
  }),
  columnHelper.accessor("symbol", {
    header: () => "Symbol",
  }),
  columnHelper.accessor("type", {
    header: () => "Type",
  }),
  columnHelper.accessor("name", {
    header: () => "Name",
  }),
  columnHelper.accessor("inOrder", {
    header: () => "In-Order",
  }),
  columnHelper.accessor("withdrawing", {
    header: () => "Withdrawing",
  }),
  columnHelper.accessor("available", {
    header: () => "Available",
  }),
  columnHelper.accessor("usdBalance", {
    header: () => "USD Value",
    cell: (props) => {
      const value = props.getValue();
      return value ? value : "-";
    },
  }),
  columnHelper.display({
    id: "transactions",
    header: () => "",
    cell: ({ row }) => {
      const accountId = row.original.id;
      const symbol = row.original.symbol;
      const tooltipId = `tooltip-txn-${accountId}`;
      // Carry the symbol to Transactions so it can pre-filter by all asset-ids
      // matching that symbol (covers the multi-chain case, e.g. USDC on
      // Ethereum + Polygon). Falls back to account-only when symbol is empty.
      const symbolParam = symbol ? `&symbol=${encodeURIComponent(symbol)}` : "";
      return (
        <div className="flex items-center">
          <Link
            to={`/transactions?account=${accountId}${symbolParam}`}
            className="flex items-center"
            data-tooltip-id={tooltipId}
            onClick={(e) => e.stopPropagation()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              className="size-6 text-current hover:text-primary transition-all"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </Link>
          <Tooltip id={tooltipId} place="top" variant="light">
            View Transactions
          </Tooltip>
        </div>
      );
    },
  }),
]
